import Splide from '@splidejs/splide';

const ENABLED = window.outerWidth >= 768;

if (document.querySelector('#Carousel') && ENABLED) {
  new Splide( '#Carousel', {
    pagination: false,
    perPage: 1,
    gap: 24,
    fixedWidth: 780,
    padding: {right: 50},
    breakpoints: {
      768: {
        fixedWidth: '100%',
        padding: {right: 0},
        arrows: false,
      },
    }
  } ).mount();
}

if (document.querySelector('#reference')) {
  new Splide( '#reference', {
    // pagination: true,
    autoHeight: true,
    gap: 112
  } ).mount();
}


if (document.querySelector('#PhotoCarousel')) {
  new Splide( '#PhotoCarousel', {
    pagination: true,
    autoHeight: true
  } ).mount();
}

document.querySelectorAll('.js-MentorsCarousel').forEach(carousel => {
  new Splide(carousel, {
    pagination: false,
    autoHeight: true,
    autoWidth: true,
    drag: false,
    gap: 15,
    omitEnd: true,
    focus: 0,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 2,
        gap: 20,
        padding: { right: 20 }
      },
      992: {
        gap: 40,
        perPage: 3
      },
    }
  }).mount();
});


if (document.querySelector('#js-ProfilesCarousel')) {
  new Splide( '#js-ProfilesCarousel', {
    pagination: false,
    autoHeight: true,
    autoWidth: true,
    drag: false,
    gap: 15,
    omitEnd: true,
    focus: 0,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 2,
        gap: 20,
        padding: { right: 20 }
      },
      992: {
        gap: 40,
        perPage: 3
      },
    }
  } ).mount();
}
